const lang = {
  LT: {
    abbreviation: "Abbreviation",
    accepted: "Priimti",
    active: "Aktyvūs",
    actual: "Actual",
    actual_hours: "Actual Hours",
    actual_scope: "Actual Scope",
    accept_offer: "Offer Accepted",
    accept_decline_offer: "Change Offer Status",
    add: "Pridėti",
    add_activity: "Add Activity",
    add_client: "Add Client",
    add_employee: "Add Employee",
    add_invoice: "Add Invoice",
    add_offer: "Add Offer",
    add_project: "Add Project",
    all: "Visi",
    amount: "Suma",
    amount_eur: "Suma, EUR",
    billing: "Apmokėjimas",
    by_skill: "By Skill",
    check_in: "Check-in",
    check_out: "Check-out",
    change_status: "Change Status",
    change_project_status: "Change Project Status",
    client: "Klientas",
    clients: "Klientai",
    collapse: "Suskleisti",
    company: "Company",
    completion: "Completion",
    copy: "Kopijuoti",
    customer: "Klientas",
    date: "Data",
    date_start: "Pradžios data",
    date_finish: "Pabaigos data",
    date_created: "Sukurta",
    date_modified: "Redaguota",
    declined: "Atšaukti",
    decline_offer: "Offer Declined",
    director: "Director",
    dur: "Trk.",
    duration: "Trukmė",
    edit_client: "Edit Client",
    edit_employee: "Edit Employee",
    edit_offer: "Edit Offer",
    edit_activity: "Edit Activity",
    efficiency: "Efficiency",
    employee: "Darbuotojas",
    employees: "Darbuotojai",
    ena: "Ena.",
    estimated: "Estimated",
    estimated_hours: "Estimated Hours",
    estimated_scope: "Estimated Scope",
    residual_scope: "Scope Remaining",
    finish: "Pabaiga",
    finish_actual: "Reali pabaiga",
    finish_task: "Finish Task",
    finished: "Pabaigti",
    first_name: "First Name",
    fitter: "Fitter",
    from: "Nuo",
    full_no: "Projekto Nr.",
    hours: "Hours",
    hourly: "Hourly",
    hourly_progress: "Hourly Progress",
    "hourly.approved": "Hourly. Estimated",
    "hourly.planned": "Hourly. Estimated",
    "hourly.actual": "Hourly. Actual",
    "hourly.residual": "Hourly. Remaining",
    "hourly.progress": "Hourly. Progress",
    "hourly.last_revision": "Hourly. Last Revision",
    inactive: "Inactive",
    invoiced: "Invoiced",
    invoice_num: "Invoice No.",
    invoiced_amount: "Invoiced Amount",
    item: "Item",
    job: "Job",
    job_description: "Job Description",
    job_type: "Job Type",
    fullname: "Vardas",
    last_name: "Pavardė",
    last_revision: "Last Revision",
    loading: "Loading",
    logout: "Logout",
    modified: "Modified",
    modify_employee_status: "Modify Employee Status",
    modify_project_completion: "Modify Project Completion",
    my_activity: "My Activity",
    my_organisations: "My Organisations",
    name: "Pavadinimas",
    new_activity: "New Activity",
    new_client: "Naujas klientas",
    new_employee: "Naujas darbuotojas",
    new_offer: "Naujas pasiūlymas",
    new_project: "Naujas projektas",
    of: "iš",
    offer: "Pasiūlymas",
    offers: "Pasiūlymai",
    organisation: "Organizacija",
    organization: "Organizacija",
    organisations: "Organizacijos",
    organizations: "Organizacijos",
    new_organization: "Nauja organizacija",
    add_organization: "Pridėti organizaciją",
    page_size: "Puslapio dydis",
    painter: "Painter",
    planned: "Planned",
    pending: "Laukiantys",
    planned_hrs: "Planned Hrs.",
    planned_hours: "Planned Hours",
    planned_hourly: "Hourly. Planned",
    planned_scope: "Scope. Planned ",
    planned_total: "Total. Planned",
    planned_warranty: "Warranty. Planned",
    primary_email: "Primary Email",
    profile: "Profile",
    progress: "Progress",
    project_details_placeholder: "Project details...",
    project_number: "Project No.",
    project: "Projektas",
    projects: "Projektai",
    project_no: "Projekto Nr.",
    project_start_date: "Projekto pradžios data",
    project_finish_date: "Projekto pabaigos data",
    residual: "Remaining",
    residual_amount: "Unpaid Amount",
    remaining_amount: "Unpaid Amount",
    residual_hours: "Hourly Remaining",
    revised: "Revised",
    qty: "Qty.",
    quantity: "Quantity",
    role: "Role",
    roles: "Roles",
    scope: "Scope",
    scope_by_skill: "Scope by Skill",
    scope_progress: "Scope Progress",
    set: "Nustatyti",
    set_page_size: "Nustatyti puslapio dydį",
    showing: "Rodoma",
    skill: "Skill",
    skills: "Skills",
    "scope.approved": "Scope. Planned",
    "scope.planned": "Scope. Estimated",
    "scope.actual": "Scope. Actual",
    "scope.residual": "Scope. Remaining",
    "scope.efficiency": "Scope. Efficiency",
    "scope.progress": "Scope. Progress",
    "scope.last_revision": "Scope. Last Revision",
    status: "Status",
    start: "Pradžia",
    start_actual: "Reali pradžia",
    start_task: "Start Task",
    started: "Started",
    stop: "Stop",
    sub: "Sub.",
    submit: "Submit",
    subcontractor: "Subcontractor",
    subcontractors: "Subcontractors",
    time: "Laikas",
    timelogs: "Time Logs",
    timesheets: "Timesheets",
    to: "Iki",
    total_amount: "Total Amount",
    unit: "Unit",
    unit_of_measurement: "Unit of Measurement",
    uom: "UoM.",
    verified: "Patvirtinti",
    vrf: "Pat.",
    unpaid: "Unpaid",
    unverified: "Nepatvirtinti",
    "warranty.approved": "Warranty. Estimated",
    "warranty.planned": "Warranty. Estimated",
    "warranty.actual": "Warranty. Actual",
    "warranty.residual": "Warranty. Remaining",
    "warranty.progress": "Warranty. Progress",
    "warranty.last_revision": "Warranty. Last Revision",
    warranty: "Warranty",
    welder: "Welder",
    year: "Metai",
    month: "Mėnesis",
    month_1: "Sau.",
    month_2: "Vas.",
    month_3: "Kov.",
    month_4: "Bal.",
    month_5: "Geg.",
    month_6: "Bir.",
    month_7: "Lie.",
    month_8: "Rgp.",
    month_9: "Rgs.",
    month_10: "Spa.",
    month_11: "Lap.",
    month_12: "Gru.",
    configurator: "Konfigūratorius",
    parameters: "Parametrai",
    constants: "Konstantos",
    price: "Kaina",
    price_calculation: "Kainos skaičiavimas",
    variation: "Variacija",
    variation_list: "Variacijų sąrašas",
    configuration_id: "Konfigūracijos ID",
    image: "Paveiksliukas",
    item_name: "Pavadinimas",
    delete: "Ištrinti",
    width: "Plotis",
    color: "Spalva",
    hotspots: "Karštieji taškai",
    duplicate_to_visible_variations: "Pritaikyti matomoms variacijoms",
    formula: "Formulė",
    manual_price: "Rankinis nustatymas",
    default_variation: "Numatyta variacija",
  },
};

const useLang = () => {
  const onTranslate = (textToTranslate) => {
    if (typeof textToTranslate !== "string") return "";
    const result = lang.LT[textToTranslate.toLocaleLowerCase()];
    if (result == null) return textToTranslate;
    return result;
  };
  return onTranslate;
};

export default useLang;
